<script>
    import {} from "../store";
    
    import Header from "../Components/Header/Header.svelte";
    import Footer from "../Components/Footer/Footer.svelte";
    import {
        checkAuth,
        getCookie,
        getUser,
        request,
        getFile,
        isAuth,
        User,
        deleteEmptyCookies,
    } from "../store";

    let user, isAuthValue;
    let showContent = false;

    isAuth.subscribe((value) => {
        isAuthValue = value;
    });

    User.subscribe((value) => {
        user = value;
    });

    function login() {
        window.location.pathname = "/api/login";
    }

    function leaveAccount() {
        document.cookie = "token=";
        window.location.reload();
        if(menu){
            menuToggle();
        }
    }

    

    checkAuth().then((response) => {
        deleteEmptyCookies();
        isAuth.update(() => response?.auth);
        if (isAuthValue) {
            getUser().then((response) => {
                User.update(() => {
                    return {
                        userID: response.id,
                        name: `${response.first_name} ${response.last_name}`,
                        avatar: response.photo_100,
                        role: response.role
                    };
                });
                showContent = true;
            });
        } else {
            showContent = true;
        }
    });
</script>

<div id="site">
    <Header/>
    <div id="site-content">
        <slot />
    </div>
    <Footer/>
</div>

<style lang="less" global>
    @import "../styles/main_page.less";
</style>
